window.$ = window.jQuery = require('jquery');

require('bootstrap');
require('bootstrap-dropdown-hover');
require('bootstrap-touchspin');
require('moment/locale/el');

import WebFontLoader from 'webfontloader';
import 'es6-promise/auto';
import moment from 'moment';
import './cart';
import './cookieconsent';
import './checkout';
import './images';
import './review';

const Search = require('./search');
const Products = require('./products');
const Scroll = require('./scroll-to-top');
const HomeSlider = require('./home-slider');

// __webpack_public_path__ = $('#assets-url').attr('href') + 'js/stores/';
__webpack_public_path__ = $('#assets-url').attr('href');

WebFontLoader.load({
  custom: {
    families: [ 'Clear Sans:400,700,300,100', 'Theano Old Style' ],
    urls: [
      __webpack_public_path__ + '/css/stores/clear-sans.css',
      __webpack_public_path__ + '/css/stores/theano-old-style.css',
    ]
  }
});

$(() => {
  $.ajaxSetup({
    headers: {
      'X-CSRF-TOKEN': window.Contraversus.csrfToken,
    }
  });

  $('.navbar-default').find('.dropdown')
    // If the search input is focused when the dropdown is toggled on,
    // focus again once the dropdown is closed.
    .on('show.bs.dropdown', (e) => {
      if (Search.isActive()) {
        $(e.target).one('hidden.bs.dropdown', () => Search.focus());
      }
    })
    .find('.dropdown-toggle')
    .bootstrapDropdownHover()
    // When the mouse leaves the dropdown toggle,
    // it should be blurred once the dropdown is closed.
    .on('mouseleave.dropdownhover', (e) => {
      $(e.target).closest('.dropdown').one('hide.bs.dropdown', (e) => {
        $(e.relatedTarget).trigger('blur');
      });
    });

  const $homeSlider = $('#home-slider');

  if ($homeSlider.length) {
    HomeSlider.init($homeSlider);
  }

  Products.init({
    el: '.js-product',
    slider: '#product-slider'
  });

  Search.init({
    selector: '.js-search'
  });

  Scroll.init('#backToTop');

  // display loader when a button is clicked
  $('.btn-loader').on('click', (e) => {
    const $button = $(e.currentTarget).addClass('disabled');
    $button.find('.fa').addClass('d-none');
    $button.find('.spinner-border').removeClass('d-none');
  });

  // enable tooltips
  $('[data-toggle="tooltip"]').tooltip();
  $('.touchspin').TouchSpin({
    buttondown_class: 'btn btn-secondary',
    buttonup_class: 'btn btn-secondary',
  });

  // display dates in greek
  $('time').each((index, el) => {
    let $el = $(el),
      date = $el.attr('datetime'),
      format = $el.data('format');

    if (format) {
      $el.text(moment(date).format(format));
    }
  });
});

function initMap() {
  let $map = $('#map');
  let options = {
    zoom: 15,
    center: new google.maps.LatLng(window.position.lat, window.position.lng),
    styles: window.styles
  };

  new google.maps.Marker({
    position: options.center,
    map: new google.maps.Map($map[0], options)
  });
}

window.initMap = initMap;
